export default class ChunkCollection<T> implements Iterable<T> {
    constructor(
        private readonly _list: Array<T> = [],
        private readonly _total: number = 0,
    ) { }

    get total(): number {
        return this._total;
    }

    [Symbol.iterator](): IterableIterator<T> {
        let _index = -1;
        const list = this._list;
        return {
            next(): IteratorResult<T>{
                if (++_index > list.length - 1) {
                    return {
                        done: true,
                        value: null,
                    };
                } else {
                    return {
                        done: false,
                        value: list[_index],
                    };
                }
            }
        } as IterableIterator<T>;
    }
}
